import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnClose = (id: string | undefined) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return () => {
    if (id !== undefined) {
      navigate(navigation.employees.id.timeOff.fullPath({ id }))
    }
  }
}
